export default __webpack_public_path__ + "static/Essential Features Every School Management System Will Have-faaaacdc0efee761ae912e625053c9cb.jpg";